/* API action types */
//Fetch all jobs
export const FETCH_JOB_PORTAL_JOB_LIST = "FETCH_JOB_PORTAL_JOB_LIST";
export const FETCH_JOB_PORTAL_JOB_LIST_SUCCESS = "FETCH_JOB_PORTAL_JOB_LIST_SUCCESS";
export const FETCH_JOB_PORTAL_JOB_LIST_FAILURE = "FETCH_JOB_PORTAL_JOB_LIST_FAILURE";
export const RESET_JOB_PORTAL_JOB_LIST = "RESET_JOB_PORTAL_JOB_LIST";

//Fetch job by jobId
export const FETCH_JOB_PORTAL_JOB = "FETCH_JOB_PORTAL_JOB";
export const FETCH_JOB_PORTAL_JOB_SUCCESS = "FETCH_JOB_PORTAL_JOB_SUCCESS";
export const FETCH_JOB_PORTAL_JOB_FAILURE = "FETCH_JOB_PORTAL_JOB_FAILURE";
export const RESET_FETCH_JOB_PORTAL_JOB_ERROR = "RESET_FETCH_JOB_PORTAL_JOB_ERROR";

//Fetch unique work locations
export const FETCH_JOB_PORTAL_WORK_LOCATIONS = "FETCH_JOB_PORTAL_WORK_LOCATIONS";
export const FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS = "FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS";
export const FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE = "FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE";

//Parse candidata resume
export const PARSE_JOB_PORTAL_RESUME = "PARSE_JOB_PORTAL_RESUME";
export const PARSE_JOB_PORTAL_RESUME_SUCCESS = "PARSE_JOB_PORTAL_RESUME_SUCCESS";
export const PARSE_JOB_PORTAL_RESUME_FAILURE = "PARSE_JOB_PORTAL_RESUME_FAILURE";
export const RESET_JOB_PORTAL_RESUME = "RESET_JOB_PORTAL_RESUME";

//Post candidate application
export const POST_JOB_PORTAL_JOB_APPLICATION = "POST_JOB_PORTAL_JOB_APPLICATION";
export const POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS = "POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS";
export const POST_JOB_PORTAL_JOB_APPLICATION_FAILURE = "POST_JOB_PORTAL_JOB_APPLICATION_FAILURE";

/* UI action types */
//Select job
export const SELECT_JOB_PORTAL_JOB = "SELECT_JOB_PORTAL_JOB";
export const RESET_JOB_PORTAL_SELECTED_JOB = "RESET_JOB_PORTAL_SELECTED_JOB";

//Search
export const SET_SEARCH_VALUES = "SET_SEARCH_VALUES";

//Filter
export const SET_FILTER_VALUES = "SET_FILTER_VALUES";
export const SET_WORKMODE_FILTER = "SET_WORKMODE_FILTER";
export const SET_LOCATION_FILTER = "SET_LOCATION_FILTER";
export const SET_JOBTYPE_FILTER = "SET_JOBTYPE_FILTER";

//Page number
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";

//Scroll position
export const SET_DIV_SCROLL_Y_POSITION = "SET_DIV_SCROLL_Y_POSITION";
export const SET_WINDOW_SCROLL_Y_POSITION = "SET_WINDOW_SCROLL_Y_POSITION";

//Set success state
export const SET_SUCCESS_STATE = "SET_SUCCESS_STATE";

// Fetch job by ID no filter
export const FETCH_JOB_PORTAL_JOB_NO_FILTER = "FETCH_JOB_PORTAL_JOB_NO_FILTER";
export const FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS = "FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS";
export const FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE = "FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE";